import * as THREE from 'three'

// count , yDirction = +-1, boundingBox = Vector3
const createParticles = (obj) => {
    const texture = obj['texture']
    const count = obj['count']
    const color = obj['color']
    const yDirection = obj['yDirection']
    const boundingBox = obj['boundingBox']
    const offset = obj['offset']
    const size = obj['size']
    const straight = obj['straight']

    const particlesGeometry = new THREE.BufferGeometry()
    
    const positions = new Float32Array(count * 3)
    const velocities = new Float32Array(count * 3)
    const colors = new Float32Array(count * 3)
    
    for (let i = 0; i < count * 3; i += 3) {
        positions[i] = (Math.random() - 0.5) * boundingBox.x + offset.x
        positions[i+1] = (Math.random()) * boundingBox.y + offset.y
        positions[i+2] = (Math.random() - 0.5) * boundingBox.z + offset.z
    
        velocities[i] = straight ? 0 : Math.floor(Math.random() * 6 - 3) * 0.1
        velocities[i+1] = Math.floor(Math.random() * 10 + 3) * 0.05 * yDirection
        velocities[i+2] = straight ? 0 : Math.floor(Math.random() * 6 - 3) * 0.1
    
        colors[i] = color.x
        colors[i+1] = color.y
        colors[i+2] = color.z
    }
    
    particlesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))
    particlesGeometry.setAttribute('velocity', new THREE.BufferAttribute(velocities, 3))
    particlesGeometry.setAttribute('color', new THREE.BufferAttribute(colors, 3))
     
    const particlesMaterial = new THREE.PointsMaterial({
        size: size,
        sizeAttenuation: true,
        alphaMap: texture,
        transparent: true,
        alphaTest: 0.001,
        depthTest: false,
        depthWrite: false,
        blending: THREE.AdditiveBlending,
        vertexColors: true,
        side: THREE.DoubleSide
    })
    
    const particles = new THREE.Points(particlesGeometry, particlesMaterial)
    particles.frustumCulled = false
    return particles
}


// Snowing effect on particles
const updateParticles = ( particles, elapsedSeconds, yDirection, yStart, count ) => {
    particles.frustumCulled = false

    const positions = particles.geometry.attributes.position.array
    const velocities = particles.geometry.attributes.velocity.array

    for (let i = 0; i < count; i++) {
        const x = i * 3
        const y = i * 3 + 1
        const z = i * 3 + 2

        positions[x] += Math.sin(elapsedSeconds * velocities[x]) * 0.01
        positions[y] += velocities[y] * 0.1
        positions[z] += Math.cos(elapsedSeconds * velocities[z]) * 0.01

        if (yDirection < 0 && positions[y] < 0) {
            positions[y] = 30
        } else if (yDirection > 0) {
            if (positions[y] > yStart + 2) {
                positions[y] = yStart
            }
        }
    }
    particles.geometry.attributes.position.needsUpdate = true
    particles.frustumCulled = false
}

export { createParticles, updateParticles }
